<template>
  <v-container fluid style="height: 100vh">
    <default-imagem />
  </v-container>
</template>

<script>
export default {
  name: "imagem",
  components: {
    "default-imagem": () => import("../components/imagens/index.vue"),
  },
};
</script>
